import React from "react";

import logotypy from "../assets/ifps-logotypy.jpg";
import { Box, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    [theme.breakpoints.down("sm")]: {
      order: -1,
    },
  },
  container: {
    padding: theme.spacing(4, 6),
    color: theme.palette.text.primary,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 2),
    },
  },
  logotypy: {
    maxWidth: "100%",
    height: "auto",
    marginBottom: theme.spacing(4),
  },
  title: {
    fontSize: "2.2em",
    fontWeight: "bold",
    marginBottom: theme.spacing(3),
    lineHeight: 1.4,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.6em",
    },
  },
  paragraph: {
    fontSize: "1.45em",
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1em",
    },
  },
  priority: {
    fontSize: "1.3em",
    lineHeight: 1.6,
    marginTop: theme.spacing(3),
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.05em",
    },
  },
}));

const LeftComponentMui = () => {
  const classes = useStyles();
  const globalTheme = useSelector((s) => s.globalTheme);
  return (
    <Grid
      item
      sm={12}
      xs={12}
      md={8}
      className={classes.gridItem}
      style={{
        color: globalTheme === "high-contrast" ? "white" : undefined,
        backgroundColor: globalTheme === "high-contrast" ? "black" : "white",
      }}
    >
      <Box className={classes.container}>
        <img
          src={logotypy}
          alt="Fundusze Europejskie dla Rozwoju Społecznego, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską"
          className={classes.logotypy}
        />

        <Box className={classes.title}>
          Witamy w systemie Instytutu Fizjologii i Patologii Słuchu
        </Box>

        <Box className={classes.paragraph}>
          Zapraszamy do udziału w badaniach w ramach projektu "Podniesienie
          kompetencji kadry zaangażowanej w pomoc osobom z różnymi zaburzeniami
          narządów zmysłów"<br/><br/> współfinansowanego ze środków
          <br/>Europejskiego Funduszu Społecznego Plus (EFS+),
          <br/>w ramach programu
          <br/>Fundusze Europejskie dla
          Rozwoju Społecznego 2021–2027 (FERS).
        </Box>

        <Box className={classes.priority}>
          Priorytet: FERS.01 – Umiejętności,
          <br />
          Działanie: FERS.01.13 – Umiejętności w sektorze zdrowia.
        </Box>
      </Box>
    </Grid>
  );
};

export default LeftComponentMui;
